<template>
  <div class="content" id="tableBox" ref="tableBox">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="areaManage">
        <span slot="label">
          <i class="border"></i> 区域管理
        </span>
        <div class="btnGroup">
          <button v-if="selectedNode" class="White" @click="delNodeInfo">删除</button>
          <button v-if="selectedNode" class="Blue" @click="editNodeInfo">修改</button>
          <button v-if="selectedNode && selectedNode.data.level === 1" class="Orange" @click="toAdjustmentAreaStructure">区域结构调整</button>
          <button v-if="selectedNode && selectedNode.data.type !== 1" class="Green" @click="addNodeInfo">增加下级区域</button>
        </div>
        <!-- 主页面 -->
        <div class="tabContent">
          <!-- 左侧区域树 -->
          <div class="areaTree">
            <el-tree
              ref="tree"
              node-key="label"
              :data="treeData"
              :props="defaultProps"
              :expand-on-click-node="false"
              :default-expand-all="false"
              :render-after-expand="true"
              lazy
              :load="loadNode"
              @node-click="handleAreaNodeClick"
            >
              <div class="tree_node" slot-scope="{ node, data }">
                <i :class="data.type === 1 ? 'leaf_dot' : ''"></i>
                <span>{{ data.name }}</span>
              </div>
            </el-tree>
          </div>
          <!-- 右侧详细信息 -->
          <div class="areaDetail">
            <div v-if="!selectedNode" class="empty">请点击左侧区域树并选择节点！</div>
            <div v-else>
              <template v-for="(dt, index) in detailModules">
                <div class="row_title">
                  <span>{{ dt.name }}</span>
                  <i :class="dt.expand ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" @click="dt.expand = !dt.expand"></i>
                </div>
                <div v-show="dt.expand" v-if="index === 0">
                  <el-row type="flex" class="row_content">
                    <el-col class="col_content">名称：{{selectedNode.data.name}}</el-col>
                    <el-col class="col_content">类型：{{selectedNode.data.type === 1 ? '安装点' : '非安装点'}}</el-col>
                    <el-col class="col_content">是否重点危险源：{{selectedNode.data.danger === 1 ? '是' : '否'}}</el-col>
                  </el-row>
                </div>
                <div v-show="dt.expand" v-if="index === 1">
                  <el-row type="flex" class="row_content">
                    <el-col class="col_content">{{selectedNode.data.model === 0 || selectedNode.parent.data.model === 0 ? '地址' : '位置'}}：{{ selectedNode.data.address }}</el-col>
                    <el-col class="col_content">{{selectedNode.data.model === 0 || selectedNode.parent.data.model === 0 ? '维度' : '横坐标'}}：{{ selectedNode.data.latitude || selectedNode.data.areaParameter.leftCenter }}</el-col>
                    <el-col class="col_content">{{selectedNode.data.model === 0 || selectedNode.parent.data.model === 0 ? '经度' : '纵坐标'}}：{{ selectedNode.data.longitude || selectedNode.data.areaParameter.topCenter }}</el-col>
                  </el-row>
                  <el-row type="flex" class="row_content_full">
                    <template v-if="selectedNode.data.model === 0 || selectedNode.parent.data.model === 0">
                      <amap mapId="amapView" :data="rootData" :plugins="['infoBar']">
                        <template #aDefaultMarker="{ data, extraData }">
                          <window :data="data" :extraData="extraData" />
                        </template>
                      </amap>
                    </template>
                    <template v-if="selectedNode.data.model === 1 && selectedNode.parent.data.model === 1">
                      <pmap mapId="pmapView" :background="selectedNode.parent.data.url" :data="rootData" :plugins="['infoBar']">
                        <template #pDefaultMarker="{ data, extraData }">
                          <window :data="data" :extraData="extraData" />
                        </template>
                      </pmap>
                    </template>
                    <template v-if="selectedNode.data.model === 2 && selectedNode.parent.data.model === 1">
                      <pmap mapId="pmapView" :background="selectedNode.parent.data.url" :data="rootData" :plugins="['infoBar']">
                        <template #pDefaultMarker="{ data, extraData }">
                          <window :data="data" :extraData="extraData" />
                        </template>
                      </pmap>
                    </template>
                    <template v-if="selectedNode.data.model === 1 && selectedNode.parent.data.model === 2">
                      <fmap
                        containerId="fmapView"
                        :mapId="selectedNode.parent.data.mapNumber"
                        :themeId="selectedNode.parent.data.url"
                        :floorCount="selectedNode.parent.data.floorNumber * 1"
                        :floorId="selectedNode.parent.data.dotNumber * 1"
                        :data="rootData"
                        :plugins="['infoBar']"
                        slotName="window"
                      />
                    </template>
                    <template v-if="selectedNode.data.model === 2 && selectedNode.parent.data.model === 2">
                      <fmap
                        containerId="fmapView"
                        :mapId="selectedNode.parent.data.mapNumber"
                        :themeId="selectedNode.parent.data.url"
                        :floorCount="selectedNode.parent.data.floorNumber * 1"
                        :floorId="selectedNode.parent.data.dotNumber * 1"
                        :data="rootData"
                        :plugins="['infoBar']"
                        slotName="window"
                      />
                    </template>
                  </el-row>
                </div>
                <div v-show="dt.expand" v-if="index === 2">
                  <el-row type="flex" class="row_content">
                    <el-col class="col_content">展现形式：{{selectedNode.data.model === 0 ? '地图' : selectedNode.data.model === 1 ? '平面图' : '蜂鸟图'}}</el-col>
                    <template v-if="selectedNode.data.model === 2">
                      <el-col class="col_content">地图编号：{{selectedNode.data.mapNumber}}</el-col>
                      <el-col class="col_content">主图编号：{{selectedNode.data.url}}</el-col>
                      <el-col class="col_content">楼层数目：{{selectedNode.data.floorNumber}}</el-col>
                      <el-col class="col_content">默认楼层：{{selectedNode.data.dotNumber}}</el-col>
                    </template>
                  </el-row>
                  <template v-if="selectedNode.data.model === 1">
                    <el-row type="flex" class="row_content_full">
                      <pmap :background="selectedNode.data.url" />
                    </el-row>
                  </template>
                  <template v-if="selectedNode.data.model === 2">
                    <el-row type="flex" class="row_content_full">
                      <fmap :mapId="selectedNode.data.mapNumber" :themeId="selectedNode.data.url" :floorCount="selectedNode.data.floorNumber * 1" :floorId="selectedNode.data.dotNumber * 1" :autoRotate="true" />
                    </el-row>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
const qs = require('qs')
// 使用插槽的组件直接引入，不要动态引入
import window from "@/components/public/window"
export default {
  components: {
    // 高德地图
    amap: () => import("@/components/public/amap/amapPainting"),
    // 平面图
    pmap: () => import("@/components/public/pmap"),
    // 蜂鸟图
    fmap: () => import("@/components/public/fmap/fmapPainting"),
    // 信息窗口
    window
  },
  watch: {
    selectedNode: {
      handler: function (n) {
        if (n) {
          this.rootData = []
          this.rootData.push(n.data)
        }
      }
    }
  },
  computed: {
    userAreaList() {
      return this.$store.state.userAreaList
    }
  },
  data() {
    return {
      tabName: 'areaManage',
      defaultProps: {
        label: 'name',
        isLeaf: 'isLeaf'
      },
      // 区域树加载完成
      treeInitialized: false,
      // 区域树数据
      treeData: [],
      // 展开区域树数据
      expandTreeData: [],
      // 用户权限区域节点
      filterNodeData: [],
      selectedNode: undefined,
      // 地图数据
      rootData: [],
      // 详情模块module
      detailModules: [
        {
          name: '基本信息',
          expand: true
        },
        {
          name: '位置信息',
          expand: true
        },
        {
          name: '展现形式',
          expand: true
        }
      ]
    }
  },
  methods: {
    initTreeData() {
      let p1 = this.$axiosget("operation/area/queryAll?ignoreCache=true")
      let that = this
      Promise.resolve().then(() => {
        p1.then(res1 => {
          res1 = res1.data.data || []
          if (res1 && res1.length) {
            let allData = []
            let tempData = res1
            while (tempData && tempData.length) {
              let tempArray = []
              tempData.forEach(td => {
                if (td.areas) {
                  tempArray = tempArray.concat(td.areas)
                }
                // 去除无关属性
                let { id, parentId, name, address, type, model, level, danger, longitude, latitude, url, areaParameter, mapNumber, floorNumber, dotNumber } = td
                td = { id, parentId, name, address, type, model, level, danger, longitude, latitude, url, areaParameter, mapNumber, floorNumber, dotNumber }
                allData.push(td)
              })
              tempData = tempArray
            }
            that.expandTreeData = allData
            that.treeData = res1
            that.treeInitialized = true
          }
        })
      }).then(() => {
        if (that.userAreaList && that.userAreaList.length) {
          that.filterNodeData = that.userAreaList
          return
        }
        let p2 = this.$axiosget("operation/area/findAreaByUserId")
        p2.then(res2 => {
          res2 = res2.data.data || []
          if (res2 && res2.length) {
            that.filterNodeData = that.filterNodeData.concat(res2)
            that.$store.commit('SET_USER_AREA', res2)
          }
        })
      })
    },
    loadNode(node, resolve) {
      let nextList = this.expandTreeData.filter(it => it.parentId === node.data.id) || []
      nextList.forEach(it => Object.assign(it, { isLeaf: it.type === 1 || !this.expandTreeData.some(t => t.parentId === it.id)}))
      // TODO 是否要过滤用户权限？
      // nextList = nextList.filter(n => {
      //   return this.filterNodeData.indexOf(n.id) >= 0
      // })
      resolve(nextList)
    },
    handleAreaNodeClick(data, node, self) {
      this.detailModules.forEach(dt => dt.expand = true )
      console.log('选中点位信息：', data, node)
      if ((data.model === 1 || node.parent.data.model === 1) && !data.areaParameter) {
        this.$axiosget("operation/area/findAreaParamater", {
          params: {
            area_id: data.id
          }
        }).then((res) => {
          let areaParameter = res.data.data[0]
          if (areaParameter) {
            Object.assign(data, { areaParameter })
            data.longitude = data.longitude ? data.longitude : areaParameter.topCenter
            data.latitude = data.latitude ? data.latitude : areaParameter.leftCenter
            node.data = data
          }
          this.selectedNode = node
        })
      } else {
        this.selectedNode = node
      }
    },
    // 区域新增
    addNodeInfo() {
      if (this.selectedNode) {
        let {
          parentAreaId = this.selectedNode.data.id,
          parentModel = this.selectedNode.data.model,
          parentLevel = this.selectedNode.data.level,
          parentImgUrl = this.selectedNode.data.url,
          parentMapNumber = this.selectedNode.data.mapNumber,
          parentFloorNumber = this.selectedNode.data.floorNumber,
          parentDotNumber = this.selectedNode.data.dotNumber
        } = this.selectedNode.data
        let parentInfo = { parentAreaId, parentModel, parentLevel, parentImgUrl, parentMapNumber, parentFloorNumber, parentDotNumber }
        this.$router.push({
          name: "addRegion",
          query: {
            parentInfo
          }
        })
      }else {
        this.$message.warning('请先选择节点！')
      }
    },
    // 区域编辑
    editNodeInfo() {
      if (this.selectedNode) {
        let {
          areaId = this.selectedNode.data.id,
          name,
          address,
          type,
          model,
          latitude,
          longitude,
          danger,
          imgUrl = this.selectedNode.data.url,
          mapNumber = this.selectedNode.data.mapNumber,
          floorNumber = this.selectedNode.data.floorNumber,
          dotNumber = this.selectedNode.data.dotNumber,
          parentModel = this.selectedNode.parent.data.model,
          parentImgUrl = this.selectedNode.parent.data.url,
          parentMapNumber = this.selectedNode.parent.data.mapNumber,
          parentFloorNumber = this.selectedNode.parent.data.floorNumber,
          parentDotNumber = this.selectedNode.parent.data.dotNumber,
          areaParameter = this.selectedNode.data.areaParameter
        } = this.selectedNode.data
        let basicInfo = { name, type, danger }
        let locationInfo = { areaId, name, address, model, latitude, longitude, parentImgUrl, parentMapNumber, parentFloorNumber, parentDotNumber, parentModel, areaParameter }
        let displayInfo = { type, model, imgUrl, mapNumber, floorNumber, dotNumber, parentModel, parentImgUrl, parentMapNumber, parentFloorNumber, parentDotNumber }
        this.$router.push({
          name: "editRegion",
          query: {
            basicInfo, locationInfo, displayInfo
          }
        })
      }else {
        this.$message.warning('请先选择节点！')
      }
    },
    // 区域删除
    delNodeInfo() {
      this.$confirm("区域删除后将无法恢复，是否确认？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let delNode = this.selectedNode
        let params = qs.stringify({ id: delNode.data.id })
        let deleteId = delNode.data.id
        let that = this
        that.$axiosdelete('operation/area/delete?' + params).then((res) => {
          let r = res.data.data
          if (r) {
            if (r === 3) {
              that.$message.warning("该区域关联了设备不能删除！")
            }
            if (r === 2) {
              that.$message.warning("该区域有下级区域不能删除！")
            }
            if (r === 1) {
              that.selectedNode = undefined
              that.filterNodeData = this.filterNodeData.filter(it => it !== deleteId)
              that.$store.commit('SET_USER_AREA', this.filterNodeData)
              that.$refs.tree.remove(delNode)
              that.$message.success("删除成功！")
              // 重新加载树
              // that.treeInitialized = false
              // this.initTreeData()
            }
          } else {
            if (res.data.status === '10000') {
              that.selectedNode = undefined
              that.filterNodeData = this.filterNodeData.filter(it => it !== deleteId)
              that.$store.commit('SET_USER_AREA', this.filterNodeData)
              that.$refs.tree.remove(delNode)
              that.$message.success("删除成功！")
              // 重新加载树
              // that.treeInitialized = false
              // this.initTreeData()
            }
          }
        })
      }).catch(() => {})
    },
    // 区域结构调整
    toAdjustmentAreaStructure() {
      this.$router.push({
        path: `/systemConfiguration/allSystemConfiguration/system/allSystem/system/region/adjustment`,
      })
    }
  },
  created() {
    this.initTreeData()
  }
}
</script>

<style lang="less" scoped>
.content {
  .tabContent {
    width: 100%;
    height: auto;
    min-height: 800px;
    display: flex;
    flex-flow: row nowrap;
    background-color: rgba(0, 0, 0, .2);
    .areaTree {
      width: 260px;
      height: 800px;
      overflow-y: auto;
      background: #181c2e;
      padding: 10px;
      .el-tree {
        background: transparent;
        color: #ccc;
        font-size: 14px;
        /deep/ .el-tree-node, .el-tree-node:focus {
          background: transparent;
          .el-tree-node__content {
            background: transparent;
            height: 40px;
            line-height: 40px;
            padding-left: 18px;
            border-bottom: 1px solid #182252;
            .el-tree-node__label {
              background: transparent;
              width: 100%;
              height: 40px;
              line-height: 40px;
            }
          }
          .el-tree-node__content:hover,
          .el-tree-node__content:focus {
            background: #212740 !important;
            border-bottom: 1px solid #0e69b0 !important;
          }
        }
        /deep/ .el-tree-node.is-current, .el-tree-node.is-expanded {
          > .el-tree-node__content {
            background: #212740 !important;
            border-bottom: 1px solid #0e69b0 !important;
          }
        }
        .tree_node {
          display: block;
          padding: 0 10px;
          i {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 2px;
            margin: 0 4px;
            background: #0e69b0;
            vertical-align: middle;
            box-shadow: 0 1px 2px 2px #000;
          }
          i.leaf_dot {
            border-radius: 5px;
            background: #6a7893;
            box-shadow: inset 0 0 0 3px #000;
          }
          span {
            display: inline-block;
            width: auto;
            line-height: 30px;
            font-size: 13px;
          }
          a {
            color: #00A3C6;
            font-size: 12px;
            margin: 0 10px;
          }
        }
      }
    }
    .areaDetail {
      width: calc(100% - 260px);
      height: auto;
      min-height: 800px;
      margin-left: 10px;
      color: #cacaca;
      background: #181c2e;
      .empty {
        width: 100%;
        text-align: center;
        line-height: 800px;
        color: #ccc;
      }
      .row_title {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #3d4963;
        span {
          box-sizing: border-box;
          display: inline-block;
          margin-left: 20px;
          padding: 0 10px;
          height: 40px;
          border-bottom: 2px solid #35b9f7;
        }
        i {
          cursor: pointer;
        }
      }
      .row_content {
        width: 96%;
        text-align: center;
        padding: 10px 0;
        margin: 20px 2%;
        border: 1px dashed #214c71;
        border-radius: 4px;
        font-size: 14px;
        .col_content {
          line-height: 40px;
          text-align: left;
          padding-left: 40px;
        }
      }
      .row_content_full {
        width: 96%;
        margin: 20px 2%;
        height: 600px;
      }
    }
  }
  /deep/ i.defaultMaker {
    font-size: 24px;
    color: #35b9f7;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/system/region/index.vue